import axios from 'axios';
import _ from 'lodash';
import SDLUtil from '@/utils/SDLUtil';

let storeFetch = null;
export const fetchMenuAll = async (forceRemote = true) => {
  if (storeFetch == null || forceRemote) {
    storeFetch = await axios.get(`${SDLUtil.API_URL}/auth/menus-user-auth`);
  }
  return storeFetch;
};

let storeMenus = [];

export default {
  async getMenus(forceRemote = false) {
    if (storeMenus.length === 0 || forceRemote) {
      try {
        const menuResponse = await fetchMenuAll(forceRemote);
        storeMenus = menuResponse.data.map(menu => {
          const defaultPage = _.find(menu.pages, ['defaulted', true]);
          if (defaultPage) {
            menu.menuUrl = defaultPage.pagePath;
            menu.componentName = defaultPage.componentName;
            menu.defaultPage = defaultPage;
          } else {
            menu.menuUrl = '/emptypage'; // memo : 2022-10-12. API로부터 메뉴를 못받기 시작하면 답이 없어진다.
            menu.componentName = 'admin/main/EmptyPage';
          }
          return menu;
        });
        return storeMenus;
      } catch (error) {
        console.warn(error);
        return [];
      }
    } else {
      return Promise.resolve(storeMenus);
    }
  },
};



// WEBPACK FOOTER //
// ./src/service/menuService.js